

import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_Popover";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_Popover__root","content":"wds_1_180_0_Popover__content","arrow":"wds_1_180_0_Popover__arrow","element":"wds_1_180_0_Popover__element","animationEnter":"wds_1_180_0_Popover__animationEnter","animationEnterActive":"wds_1_180_0_Popover__animationEnterActive","animationExit":"wds_1_180_0_Popover__animationExit","animationExitActive":"wds_1_180_0_Popover__animationExitActive"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"contentArrowSize":"8px"}; 
export var vars = {"wds-popover-border":"--wds-popover-border","wds-shadow-surface-overlay":"--wds-shadow-surface-overlay","wds-color-fill-surface-overlay":"--wds-color-fill-surface-overlay","wds-color-fill-surface-overlay-dark":"--wds-color-fill-surface-overlay-dark","wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-font-size-body-small":"--wds-font-size-body-small","wds-font-line-height-body-small":"--wds-font-line-height-body-small"}; 




